// colors
import { colors } from '../../../../../packages/colors';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  drawer: {
    '& .MuiPaper-root': {
      maxWidth: '800px !important',
      overflowY: 'hidden',
    },
    '& .drawerBody': {
      backgroundColor: colors.neutral50,
      padding: 0,
      minHeight: 'calc(100vh - 108px)',
      overflowY: 'hidden',
    },
  },
  container: {
    flex: 1,
    height: '100%',
    backgroundColor: colors.white,
    overflowY: 'hidden',
  },
  searchWrap: {
    backgroundColor: colors.white,
    padding: 32,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16,
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  searchInput: {
    width: '100%',
    borderRadius: 6,
    backgroundColor: colors.white,
    height: 48,
    padding: 0,
  },
  appointments: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    padding: 32,
    backgroundColor: colors.neutral50,
    height: 'calc(100vh - 113px - 108px)',
    overflowY: 'auto',
  },
  block: {
    backgroundColor: colors.white,
    borderRadius: 8,
    padding: 32,
    alignItems: 'center',
    boxShadow:
      ' 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04)',
  },
  blockTitle: {
    fontSize: 12,
    lineHeight: '20px',
    fontWeight: 800,
    flex: 0.3,
    textTransform: 'uppercase',
    color: colors.secondary500,
  },
  blockSubtitle: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 500,
    flex: 0.4,
  },
  time: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 500,
    color: colors.neutral700,
  },
  ul: {
    margin: 0,
  },
  noItem: {
    color: colors.neutral600,
    fontSize: 16,
  },
});
